/*
 * @Author: 肖玲
 * @Date: 2023-06-01 20:13:45
 * @LastEditTime: 2023-07-03 18:37:58
 * @LastEditors: 肖玲
 * @Description: 
 * @FilePath: \p2ps_vip_web\src\router\jurisdiction-manage\dept-juris-manage\index.js
 * 文件备注
 */
/**
 * @author 戴旭
 * @createDate 2023/02/28 15:26:07
 * @updateDate 2023/02/28 15:26:07
 * @description: 部门辖区管理
*/

import deptQuarterRouter from './modules/deptQuarter'
import jurisRelationsRouter from './modules/jurisRelations';
import baseInfoRouter from './modules/baseInfo';
import futureFramework from './modules/futureFramework';

const deptJurisManageRouter = [].concat(deptQuarterRouter).concat(jurisRelationsRouter).concat(baseInfoRouter).concat(futureFramework)

export default deptJurisManageRouter
